import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { axiosPrivate } from '../../../../api/axios';
import { Box, Button, Collapse, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, MenuItem, Select, Tooltip, Link, List, ListItem, ListItemIcon, Divider, IconButton,
  Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme} from '@mui/material';
import { makeStyles } from "@mui/styles";
  import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Header from "../../../../components/Header";
import CircleIcon from '@mui/icons-material/Circle';
import HelpIcon from '@mui/icons-material/Help';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridEditInputCell,
  GridColDef
} from '@mui/x-data-grid';
import ZoneCreator from '../ZoneCreator/index.jsx';
import step1AnswerTable from './step1AnswerTable.png';
import step2AnswerTable from './step2AnswerTable.png';
import step3AnswerTable from './step3AnswerTable.png';



const useStyles = makeStyles({
  root: {
    '& .cold': {
      backgroundColor: '#b9d5ff91',
      color: '#1a3e72',
    },
    '& .hot': {
      backgroundColor: '#FFECA1',
      color: '#1a3e72',
    },
  },
});


const MATM = ({setActiveStep}) => {

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [openInstructions, setOpenInstructions] = useState(true);
  const { assessmentID } = useParams();
  const [allZoneData, setAllZoneData] = React.useState();
  const [refresh, setRefresh] = useState(true);
  const [userAddedZoneTemp, setUserAddedZoneTemp] = useState("");
  const [allZoneDataLength, setAllZoneDataLength] = useState();
  const [questionIndex, setQuestionIndex] = useState(0);
  const [rows, setRows] = useState();
  const [allCriticalAssetData, setAllCriticalAssetData] = useState();
  const [scenarioIndex, setScenarioIndex] = useState(0);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [newZoneName, setNewZoneName] = useState("");
  const [newZoneData, setNewZoneData] = useState();
  const [newZoneDescription, setNewZoneDescription] = useState(newZoneData?.zoneDescription);
  const [openOriginalText, setOpenOriginalText] = useState(false);
  const [openQuestionMetrics, setOpenQuestionMetrics] = useState(false);
  const [uniqueAssetList, setUniqueAssetList] = useState([]);
  const assessmentAssetTypeList =[];
  const [assessmentAssetTypeListUnique, setAssessmentAssetTypeListUnique] = useState([]);
  const dynamicQuestionList = [];

  const classes = useStyles();
  
  const physicalSecurityScenario = [
  {
    id: 'matmAnswersByZone',
    name: 'Answers',
    description: 'Choose the best option from the dropdown menu that addresses the mitigation on the right for each zone.'
  },
];
  
  const columnFieldsFoot = [ 'M0801',	'M0936',	'M0915',	'M0949',	'M0913',	'M0948',	'M0947',	'M0800',	'M0946',	'M0945',	'M0802',	'M0953',	'M0803',	'M0942',	'M0808',	'M0941',	'M0938',	'M0950',	'M0937',	'M0804',	'M0935',	'M0934',	'M0805',	'M0806',	'M0932',	'M0807',	'M0931',	'M0930',	'M0928',	'M0809',	'M0810',	'M0927',	'M0926',	'M0811',	'M0922',	'M0944',	'M0924',	'M0921',	'M0812',	'M0954',	'M0813',	'M0920',	'M0814',	'M0817',	'M0919',	'M0951',	'M0918',	'M0917',	'M0818',	'M0916',	'M0815', "DS0015", 	"DS0039", 	"DS0017", 	"DS0016", 	"DS0022", 	"DS0001", 	"DS0028", 	"DS0011", 	"DS0033", 	"DS0029", 	"DS0040", 	"DS0009", 	"DS0003", 	"DS0012", 	"DS0019", 	"DS0002", 	"DS0024" ]


  const appSrvr = [
"M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0928",
"M0953",
"M0927",
"M0811",
"M0938",
"M0804",
"M0937",
"M0807",
"M0920",
"M0926",
"M0922",
"M0803",
"M0941",
"M0917",
"M0801",
"M0800",
"M0948",
"M0950",
"M0951",
"M0916",
"M0919",
"M0936",
"M0935",
"M0932",
"M0918",
"M0816",
"M0944",
"M0945",
"M0808",
"M0934",
"M0924",
"M0817",
"M0915",
"M0913",
  ];

  const cntlSrvr = [
    "M0805",
"M0807",
"M0812",
"M0953",
"M0810",
"M0811",
"M0803",
"M0941",
"M0809",
"M0922",
"M0947",
"M0945",
"M0949",
"M0930",
"M0951",
"M0816",
"M0804",
"M0800",
"M0801",
"M0946",
"M0802",
"M0808",
"M0937",
"M0813",
"M0931",
"M0921",
"M0917",
"M0806",
"M0818",
"M0938",
"M0927",
"M0918",
"M0948",
"M0942",
"M0924",
"M0950",
"M0919",
"M0932",
"M0814",
"M0944",
"M0934",
"M0928",
"M0817",
  ];

  const dataGtwy = [
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0953",
"M0927",
"M0811",
"M0938",
"M0920",
"M0926",
"M0922",
"M0815",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0936",
"M0935",
"M0932",
"M0918",
"M0816",
"M0944",
"M0945",
"M0808",
"M0934",
"M0928",
"M0924",
"M0817",
"M0946",
"M0941",
"M0915",
"M0913",
  ];

  const dataHstrn = [
"M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0807",
"M0928",
"M0953",
"M0927",
"M0811",
"M0938",
"M0804",
"M0937",
"M0920",
"M0926",
"M0922",
"M0941",
"M0918",
"M0917",
"M0803",
"M0801",
"M0815",
"M0800",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0936",
"M0935",
"M0932",
"M0816",
"M0944",
"M0945",
"M0808",
"M0934",
"M0924",
"M0817",
"M0915",
"M0913",
  ];

  const fldIO = [
    "M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0920",
"M0953",
"M0926",
"M0922",
"M0927",
"M0815",
"M0938",
"M0816",
"M0934",
"M0928",
"M0945",
"M0817",
"M0951",
"M0916",
"M0936",
"M0915",
"M0913",
"M0932",
"M0918",
"M0808",
"M0806",
  ];

  const hmiMitList = [
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0928",
"M0953",
"M0927",
"M0811",
"M0938",
"M0920",
"M0926",
"M0922",
"M0803",
"M0941",
"M0917",
"M0815",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0816",
"M0944",
"M0945",
"M0918",
"M0808",
"M0932",
"M0934",
"M0924",
"M0817",
"M0946",
"M0818",
"M0949",
"M0921",
"M0936",
"M0915",
"M0913",

  ];

  const iedMitList = [
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0953",
"M0927",
"M0811",
"M0920",
"M0926",
"M0922",
"M0815",
"M0938",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0944",
"M0918",
"M0818",
"M0816",
"M0808",
"M0932",
"M0934",
"M0928",
"M0945",
"M0924",
"M0817",
"M0946",
"M0941",
"M0936",
"M0915",
"M0913",
  ];

  const jmpHst = [
    "M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0928",
"M0807",
"M0953",
"M0927",
"M0811",
"M0938",
"M0804",
"M0937",
"M0920",
"M0926",
"M0922",
"M0803",
"M0941",
"M0917",
"M0801",
"M0815",
"M0800",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0936",
"M0935",
"M0932",
"M0918",
"M0816",
"M0944",
"M0945",
"M0808",
"M0934",
"M0924",
"M0949",
"M0921",
"M0817",
"M0915",
"M0913",

  ];

  const plcMitList = [
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0953",
"M0927",
"M0811",
"M0920",
"M0926",
"M0922",
"M0815",
"M0938",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0944",
"M0816",
"M0918",
"M0945",
"M0818",
"M0946",
"M0808",
"M0941",
"M0932",
"M0934",
"M0928",
"M0817",
"M0936",
"M0915",
"M0913",

  ];

  const rtuMitList =[
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0953",
"M0927",
"M0811",
"M0920",
"M0926",
"M0922",
"M0815",
"M0938",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0944",
"M0918",
"M0818",
"M0816",
"M0808",
"M0932",
"M0934",
"M0928",
"M0924",
"M0945",
"M0817",
"M0946",
"M0941",
"M0936",
"M0915",
"M0913",
  ];

  const routersMitList = [
    "M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0953",
"M0927",
"M0811",
"M0804",
"M0937",
"M0807",
"M0920",
"M0926",
"M0922",
"M0801",
"M0800",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0936",
"M0935",
"M0932",
"M0918",
"M0944",
  ];

  const sftyCntrol = [
"M0801",
"M0800",
"M0802",
"M0937",
"M0804",
"M0807",
"M0930",
"M0813",
"M0947",
"M0942",
"M0931",
"M0810",
"M0814",
"M0953",
"M0927",
"M0811",
"M0920",
"M0926",
"M0922",
"M0815",
"M0938",
"M0948",
"M0950",
"M0919",
"M0951",
"M0916",
"M0944",
"M0816",
"M0918",
"M0945",
"M0946",
"M0808",
"M0941",
"M0932",
"M0934",
"M0928",
"M0924",
"M0817",
"M0818",
"M0936",
"M0915",
"M0913",
  ];

  const vpnSrvr = [
"M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0807",
"M0953",
"M0927",
"M0811",
"M0804",
"M0937",
"M0920",
"M0926",
"M0922",
"M0801",
"M0800",
"M0948",
"M0950",
"M0951",
"M0916",
"M0919",
"M0936",
"M0935",
"M0932",
"M0918",
"M0944",
"M0938",
"M0816",
"M0808",
"M0934",
"M0928",
"M0945",
"M0924",
"M0817",
"M0946",
"M0941",
"M0915",
"M0913",
  ];

  const workstationsMitList =[
"M0947",
"M0802",
"M0942",
"M0931",
"M0930",
"M0810",
"M0813",
"M0814",
"M0928",
"M0807",
"M0953",
"M0927",
"M0811",
"M0938",
"M0804",
"M0937",
"M0920",
"M0926",
"M0922",
"M0803",
"M0941",
"M0917",
"M0801",
"M0800",
"M0948",
"M0950",
"M0921",
"M0951",
"M0916",
"M0919",
"M0816",
"M0944",
"M0945",
"M0808",
"M0932",
"M0934",
"M0924",
"M0918",
"M0949",
"M0817",
"M0936",
"M0915",
"M0913",
"M0806",
  ];



  const assetDeterminationQuestions = [
  {
    id: 'M0801',
    questionCategory: 'Access Management',
    questionCategoryDescription: 'Access Management technologies can be used to enforce authorization polices and decisions, especially when existing field devices do not provided sufficient capabilities to support user identification and authentication. These technologies typically utilize an in-line network device or gateway system to prevent access to unauthenticated users, while also integrating with an authentication service to first verify user credentials.',
    question: 'Are authorization and authentication enforced for each cyber asset? These technologies include username and password, common access cards (or other token), light-weight directory protocol servers (like Active Directory), or Remote Authentication Dial-In User Service (RADIUS).',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  },
  {
    id: 'M0936',
    questionCategory: 'Account Use Policies',
    questionCategoryDescription: 'Configure features related to account use like login attempt lockouts, specific login times, password strength, removing default accounts/passwords, and inactivity lockout.',
    question: 'Are account use features such as login attempts, inactivity timeouts, password strength configure?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '2. ',
    questionTitle: 'External Access: Visual access w/asset protections based on physical location, structure/equipment, resiliency and facility security:'
  },
  {
    id: 'M0915',
    questionCategory: 'Active Directory Configuration',
    questionCategoryDescription: 'Configure Active Directory to prevent use of certain techniques; use security identifier (SID) Filtering, etc.',
    question: 'Is Active Directory configured to prevent use of certain techniques; use security identifier (SID) Filtering, allowed logon times, access control lists, auditing capability',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '3. ',
    questionTitle: 'External Access: Visual access w/asset protections based on physical location, structure/equipment, resiliency and facility security:'
  },
  { 
    id:'M0949',
    questionCategory:'Antivirus/Antimalware',
    questionCategoryDescription:'Use signatures or heuristics to detect malicious software. Within industrial control environments, antivirus/antimalware installations should be limited to assets that are not involved in critical or real-time operations. To minimize the impact to system availability, all products should first be validated within a representative test environment before deployment to production systems.',
    question: 'Do you use antivirus/antimalware software in this environment?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''}, 
  { 
    id:'M0913',
    questionCategory: 'Application Developer Guidance',
    questionCategoryDescription: 'This mitigation describes any guidance or training given to developers of applications to avoid introducing security weaknesses. Ensure that applications and devices do not store sensitive data or credentials insecurely (e.g., plaintext credentials in code, published credentials in repositories, or credentials in public cloud storage).',
    question: 'Do you have a process to prevent introducing poorly developed cyber assets to the environment (storing sensitive data or credentials in clear text, hardcoded passwords, etc.)?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: 'M0913'}, 
  { 
    id:'M0948',
    questionCategory: 'Application Isolation and Sandboxing',
    questionCategoryDescription: 'Restrict the execution of code to a virtual environment on or in-transit to an endpoint system.',
    question: 'Do you restrict the execution of code to a virtual environment on or in-transit to an endpoint system?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0947',
    questionCategory: 'Audit',
    questionCategoryDescription: 'Perform audits or scans of systems, permissions, insecure software, insecure configurations, etc. to identify potential weaknesses. Perform periodic integrity checks of the device to validate the correctness of the firmware, software, programs, and configurations. Integrity checks, which typically include cryptographic hashes or digital signatures, should be compared to those obtained at known valid states, especially after events like device reboots, program downloads, or program restarts.',
    question: 'Do you audit or scan cyber assets for permissions, insecure configurations, and unauthorized software/firmware?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0800',
    questionCategory: 'Authorization Enforcement',
    questionCategoryDescription: 'The device or system should restrict read, manipulate, or execute privileges to only authenticated users who require access based on approved security policies. Role-based Access Control (RBAC) schemes can help reduce the overhead of assigning permissions to the large number of devices within an ICS. For example, IEC 62351 provides examples of roles used to support common system operations within the electric power sector , while IEEE 1686 defines standard permissions for users of IEDs.',
    question: 'Do the cyber assets in the environment restrict read, write, execute privileges to authorized personnel only?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0946',
    questionCategory: 'Boot Integrity',
    questionCategoryDescription: 'Use secure methods to boot a system and verify the integrity of the operating system and loading mechanisms.',
    question: 'Do you use secure methods to boot cyber assets and verify the integrity of the operating system?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0945',
    questionCategory: 'Code Signing',
    questionCategoryDescription: 'Enforce binary and application integrity with digital signature verification to prevent untrusted code from executing.',
    question: 'Do you verify the integrity of software/firmware? Digital signature verification using file hashes should be used before installing new applicaitons. Code signing technology should be used before allowing software to execute.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not implemented - software integrity is not verified before installing or executing software.',
    questionMetrics2: 'Partially Implemented - software integrity is verified for some downloaded files before installation but not processes executed on cyber assets.',
    questionMetrics3: 'Largely Implemented - software integrity is verified for most downloaded files before installation and before processes executed on at least 50% of cyber assets.', 
    questionMetrics4: 'Fully Implemented - software integrity is verified for all downloaded files before installation and before processes executed on at least 75% of cyber assets.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0802',
    questionCategory: 'Communication Authenticity',
    questionCategoryDescription: 'When communicating over an untrusted network, utilize secure network protocols that both authenticate the message sender and can verify its integrity. This can be done either through message authentication codes (MACs) or digital signatures, to detect spoofed network messages and unauthorized connections.',
    question: 'Do you use secure network protocols that both authenticate the message sender and verify the integrity of the message? ',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - secure protocols may be used based on system defaults.',
    questionMetrics2: 'Partially Implemented - secure network protocols are used for untrusted networks for some cyber assets.',
    questionMetrics3: 'Largely Implemented - secure network protocols are used for trusted and untrusted networks for at least 50% of cyber assets.', 
    questionMetrics4: 'Fully Implemented - secure network protocols are used for trusted and untrusted networks for at least 75% of cyber assets.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0953',
    questionCategory: 'Data Backup',
    questionCategoryDescription: 'Take and store data backups from end user systems and critical servers. Ensure backup and storage systems are hardened and kept separate from the corporate network to prevent compromise. Maintain and exercise incident response plans , including the management of "gold-copy" back-up images and configurations for key systems to enable quick recovery and response from adversarial activities that impact control, view, or availability.',
    question: 'Do you regularly backup and maintain data for end user systems and critical servers?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - data is not backed up.',
    questionMetrics2: 'Partially Implemented - there are backups of critical data (including the ability to restore applications and operating systems) for some critical cyber assets.',
    questionMetrics3: 'Largely Implemented - full backups of critical data (including the ability to restore applications and operating systems) for at least 50% of critical cyber assets are maintained.', 
    questionMetrics4: 'Fully Implemented - full backups of critial data (including the ability to restore applications and operating systems) for all critical cyber assets are maintained.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0803',
    questionCategory: 'Data Loss Prevention',
    questionCategoryDescription: 'Data Loss Prevention (DLP) technologies can be used to help identify adversarial attempts to exfiltrate operational information, such as engineering plans, trade secrets, recipes, intellectual property, or process telemetry. DLP functionality may be built into other security products such as firewalls or standalone suites running on the network and host-based agents. DLP may be configured to prevent the transfer of information through corporate resources such as email, web, and physical media such as USB for host-based solutions.',
    question: 'Do you use data loss prevention (DLP) technologies to detect or prevent the exfiltration of data? DLP functionality may be built into firewalls, stand-alone appliances, or host-based agents.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no DLP capability.',
    questionMetrics2: 'Partially Implemented - some DLP capability covering at least some critical cyber assets or critical data.',
    questionMetrics3: 'Largely Implemented - a DLP capability exists for most critical cybers assets and critical data to prevent a data breach. The DLP technology is not installed in this specfiic zone, but the technology protects data from this zone.', 
    questionMetrics4: 'Fully Implemented - a DLP capability exists for most cybers assets and data at least at the zone boundary.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0942',
    questionCategory: 'Disable or Remove Feature or Program',
    questionCategoryDescription: 'Remove or deny access to unnecessary and potentially vulnerable software to prevent abuse by adversaries.',
    question: 'Do you securely configure cyber assets by removing unnecessary software and disabling unused ports, protocols, services, and features?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0808',
    questionCategory: 'Encrypt Network Traffic',
    questionCategoryDescription: 'Utilize strong cryptographic techniques and protocols to prevent eavesdropping on network communications.',
    question: 'Is network traffic encrypted?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - traffic may be encrypted based on system defaults.',
    questionMetrics2: 'Partially Implemented - traffic is encrypted at the zone boundary.',
    questionMetrics3: 'Largely Implemented - traffic is encrypted at the zone boundary using strong encryption techniques. Traffic within the zone is encrypted for some critical cyber assets.', 
    questionMetrics4: 'Fully Implemented - traffic is encrypted at the zone boundary using strong encryption techniques. Traffic within the zone is encrypted for all cyber assets.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0941',
    questionCategory: 'Encrypt Sensitive Information',
    questionCategoryDescription: 'Protect sensitive data-at-rest with strong encryption.',
    question: 'Is data-at-rest encrypted? This could include database encryption, file encryption, full disk encryption, etc.', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0938',
    questionCategory: 'Execution Prevention',
    questionCategoryDescription: 'Block execution of code on a system through application control, and/or script blocking.',
    question: 'Do you configure operating systems to block code execution through application control and/or script blocking?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0950',
    questionCategory: 'Exploit Protection',
    questionCategoryDescription: 'Use capabilities to detect and block conditions that may lead to or be indicative of a software exploit occurring.',
    question: 'Do you use capabilities to detect and block attempts to exploit software, such as next generation firewalls, web application firewalls or Windows Defender Exploit Guard (WDEG)?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0937',
    questionCategory: 'Filter Network Traffic',
    questionCategoryDescription: 'Use network appliances to filter ingress or egress traffic and perform protocol-based filtering. Configure software on endpoints to filter network traffic. Perform inline allow/denylisting of network messages based on the application layer (OSI Layer 7) protocol, especially for automation protocols. Application allowlists are beneficial when there are well-defined communication sequences, types, rates, or patterns needed during expected system operations. Application denylists may be needed if all acceptable communication sequences cannot be defined, but instead a set of known malicious uses can be denied (e.g., excessive communication attempts, shutdown messages, invalid commands). Devices performing these functions are often referred to as deep-packet inspection (DPI) firewalls, context-aware firewalls, or firewalls blocking specific automation/SCADA protocol aware firewalls.',
    question: 'Do you use deep packet inspection firewalls and/or application allowlists?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - No such capability for the specified zone.',
    questionMetrics2: 'Partially Implemented - a stateful firewall is installed and ruleset blocking most unnecessary protocols.',
    questionMetrics3: 'Largely Implemented - a deep packet inspection firewall or like capability is at the boundary of the specific zone but needs significant tuning to be effective.', 
    questionMetrics4: 'Fully Implemented - a well-tuned deep packet inspection firewall or like capability is at the boundary of the specific zone and cyber assets that support application allowlists are configured and enabled.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0804',
    questionCategory: 'Human User Authentication',
    questionCategoryDescription: 'Require user authentication before allowing access to data or accepting commands to a device. While strong multi-factor authentication is preferable, it is not always feasible within ICS environments. Performing strong user authentication also requires additional security controls and processes which are often the target of related adversarial techniques (e.g., Valid Accounts, Default Credentials). Therefore, associated ATT&CK mitigations should be considered in addition to this, including Multi-factor Authentication, Account Use Policies, Password Policies, User Account Management, Privileged Account Management, and User Account Control.',
    question: 'Do you require user authentication before allowing access to data or accepting commands to a device?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - authentication may be required based on system defaults.',
    questionMetrics2: 'Partially Implemented - user authentication is require on 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented - user authentication is require on 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented - user authentication is require on 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0935',
    questionCategory: 'Limit Access to Resource Over Network',
    questionCategoryDescription: 'Prevent access to file shares, remote access to systems, unnecessary services. Mechanisms to limit access may include use of network concentrators, RDP gateways, etc.',
    question: 'Do you limit access to cyber assets from remote access using VPNs, RDP servers, or like system?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - access to cyber assets is not strictly regulated.',
    questionMetrics2: 'Partially Implemented - access to critical cyber assets is limited by point-to-point protocols like SSH or SFTP, but is not strictly managed.',
    questionMetrics3: 'Largely Implemented - a VPN server, RDP server, or like system is used to limit access to cyber assets.', 
    questionMetrics4: 'Fully Implemented - a VPN server, RDP server, or like system is used to access a jump host in a specific zone that accesses cyber assets in the zone. Or access to cyber assets in this zone are inaccessible outside the zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0934',
    questionCategory: 'Limit Hardware Installation',
    questionCategoryDescription: 'Block users or groups from installing or using unapproved hardware on systems, including USB devices.',
    question: 'The principle of least privilege is applied. Users do not have privileged accounts and cannot install unapproved hardware or software on cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - Yes, users are given privileged accounts by default.',
    questionMetrics2: 'Partially Implemented - most users do not have privileged accounts. However, there some systems that users have privileged accounts, and these systems are poorly managed.',
    questionMetrics3: 'Largely Implemented - most users do not have privileed accounts. However, there is a tightly managed process for users to request privileged accounts.', 
    questionMetrics4: 'Fully Implemented - only properly trained personnel with a management-approved business need have privileged accounts.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0805',
    questionCategory: 'Mechanical Protection Layers',
    questionCategoryDescription: 'Utilize a layered protection design based on physical or mechanical protection systems to prevent damage to property, equipment, human safety, or the environment. Examples include interlocks, rupture disk, release values, etc.',
    question: 'Are systems designed to fail-safe using mechanical protection systems like interlocks, release valves, and rupture disks?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0806',
    questionCategory: 'Minimize Wireless Signal Propagation',
    questionCategoryDescription: 'Wireless signals frequently propagate outside of organizational boundaries, which provide opportunities for adversaries to monitor or gain unauthorized access to the wireless network. To minimize this threat, organizations should implement measures to detect, understand, and reduce unnecessary RF propagation.',
    question: 'Do you have a process to detect and reduce unnesscary wireless propagation?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such activity exists.',
    questionMetrics2: 'Partially Implemented - wireless access points are installed and configured to limit RF propagation.',
    questionMetrics3: 'Largely Implemented - wireless access points are installed and configured to limit RF propagation and wireless scanning is completed at installation.', 
    questionMetrics4: 'Fully Implemented - wireless signal and access point scanning is regularly accomplished and RF propagation is mostly limited to only necessary locations.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0932',
    questionCategory: 'Multi-factor Authentication',
    questionCategoryDescription: 'Use two or more pieces of evidence to authenticate to a system; such as username and password in addition to a token from a physical smart card or token generator. Within industrial control environments assets such as low-level controllers, workstations, and HMIs have real-time operational control and safety requirements which may restrict the use of multi-factor.',
    question: 'Is multi-factor authentication is used to access cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - multi-factor authentication is not used.',
    questionMetrics2: 'Partially Implemented - multi-factor authentication is used on some cyber assets in the zone.',
    questionMetrics3: 'Largely Implemented - multi-factor authentication is required to access the zone at the boundary and for most cyber assets in the zone.', 
    questionMetrics4: 'Fully Implemented multi-factor authentication is implemented on all cyber assets where it is supported.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0807',
    questionCategory: 'Network Allowlists',
    questionCategoryDescription: 'Network allowlists can be implemented through either host-based files or system hosts files to specify what connections (e.g., IP address, MAC address, port, protocol) can be made from a device. Allowlist techniques that operate at the application layer (e.g., DNP3, Modbus, HTTP) are addressed in Filter Network Traffic mitigation.',
    question: 'Are network allowlists configured on each cyber asset to authorize connections from a specific cyber asset?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - allowlists are configured for 0-10% of cyber assets in the zone.',
    questionMetrics2: 'Partially Implemented - allowlists are configured for 11-50% of cyber assets in the zone.',
    questionMetrics3: 'Largely Implemented - allowlists are configured for 51-89% of cyber assets in the zone.', 
    questionMetrics4: 'Fully Implemented - allowlists are configured for 90-100% of cyber assets in the zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0931',
    questionCategory: 'Network Intrusion Prevention',
    questionCategoryDescription: 'Use intrusion detection signatures to block traffic at network boundaries. In industrial control environments, network intrusion prevention should be configured so it will not disrupt protocols and communications responsible for real-time functions related to control or safety.',
    question: 'Do you use a Network Intrusion Prevention system?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - this capability is not used for the zone.',
    questionMetrics2: 'Partially Implemented - a signature-based network intrusion prevention system is used to detect possible threats, but does not take action to prevent malicious traffic.',
    questionMetrics3: 'Largely Implemented - a behavior-based or signature-based behavior-based network intrusion prevention system is used to block malicious traffic for a portion of the zone.',  
    questionMetrics4: 'Fully Implemented - a behavior-based network intrusion prevention system is used to block malicious traffic on this zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0930',questionCategory: 'Network Segmentation',
    questionCategoryDescription: 'Architect sections of the network to isolate critical systems, functions, or resources. Use physical and logical segmentation to prevent access to potentially sensitive systems and information. Use a DMZ to contain any internet-facing services that should not be exposed from the internal network. Restrict network access to only required systems and services. In addition, prevent systems from other networks or business functions (e.g., enterprise) from accessing critical process control systems. For example, in IEC 62443, systems within the same secure level should be grouped into a zone, and access to that zone is restricted by a conduit, or mechanism to restrict data flows between zones by segmenting the network.',
    question: 'Do you physically and logically segment your network to prevent access to critical cyber assets or data?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - the network is generally flat. IT, OT, and HVAC may be isolated, but are not intentionally segmented.',
    questionMetrics2: 'Partially Implemented - the network is isolated by function, such as IT, OT, or HVAC, using VLANs or similar technology implemented at the switch (Layer 2).',
    questionMetrics3: 'Largely Implemented - the network is isolated by criticality using VLANs or similar technology, implemented at the firewall.', 
    questionMetrics4: 'Fully Implemented - the network is isolated using a combination of software-defined networking and physically seperated networks with strong access control rules for each network at the boundary.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0928',
    questionCategory: 'Operating System Configuration',
    questionCategoryDescription: 'Make configuration changes related to the operating system or a common feature of the operating system that result in system hardening against techniques.',
    question: 'Are operating systems securely configured? ',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: 'Examples of secure configurations include CIS Benchmarks, DISA STIGs, or vendor hardening guides for appliances.',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0809',
    questionCategory: 'Operational Information Confidentiality',
    questionCategoryDescription: 'Deploy mechanisms to protect the confidentiality of information related to operational processes, facility locations, device configurations, programs, or databases that may have information that can be used to infer organizational trade-secrets, recipes, and other intellectual property (IP).',
    question: 'Are mechanisms deployed to protect operaitonal data?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented -  data may have some level of protection based on system defaults or network segmentation and access control processes.',
    questionMetrics2: 'Partially Implemented - operational data is generally protected by limiting access based on personnel training and management approval. This technique relies entirely on user competency to protect data.',
    questionMetrics3: 'Largely Implemented - operational data is protected at rest and in transit using modern cyrptography methods.', 
    questionMetrics4: 'Fully Implemented - operational data is protected at rest and in transit using modern cyrptography methods. Cyber assets protect data-in-process using techniques such as Control Flow Guard (CFG) and Address Space Layout Randomization (ASLR).',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0810',
    questionCategory: 'Out-of-Band Communications Channel',
    questionCategoryDescription: 'Have alternative methods to support communication requirements during communication failures and data integrity attacks.',
    question: 'Do you have alternative methods to support communication requirements during communication failures and data integrity attacks.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such capability exists.',
    questionMetrics2: 'Partially Implemented - at least one out-of-band communication method exists for some functions, but significant gaps exists.',
    questionMetrics3: 'Largely Implemented - at least one out-of-band communication method and process exists for critical mission areas.', 
    questionMetrics4: 'Fully Implemented - two or more reliable, out-of-band communication methods and processes exists supporting all mission areas and are regularly tested.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0927',
    questionCategory: 'Password Policies',
    questionCategoryDescription: 'Set and enforce secure password policies for accounts.',
    question: 'Does your organization have and enforce a secure password policy for cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no policy exists or is not enforced.',
    questionMetrics2: 'Partially Implemented - a policy exists, but is only enforced for less than 50% of cyber assets.',
    questionMetrics3: 'Largely Implemented - policy exists, and is enforced for most cyber assets.', 
    questionMetrics4: 'Fully Implemented - policy exists and is enforced for all cyber assets. It requires minimum password length and complexity. Password reuse is prohibited, and passwords must be changed annually. Shared accounts are limited to cyber assets that cannot support individual user accounts.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0926',
    questionCategory: 'Privileged Account Management',
    questionCategoryDescription: 'Manage the creation, modification, use, and permissions associated to privileged accounts, including SYSTEM and root.',
    question: 'Are privileged accounts managed for cyber assets?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - the default admin or root account is shared by system administrators in the environment.',
    questionMetrics2: 'Partially Implemented - Creating or modifying privileged accounts requires management approval.',
    questionMetrics3: 'Largely Implemented - system administrators have separate user and privileged accounts. Creating or modifying privileged accounts requires management approval.', 
    questionMetrics4: 'Fully Implemented - system administrators have separate user and privileged accounts. Domain admins have individual accounts. Creating or modifying privileged accounts requires management approval. An acceptable use policy for privileged accounts exists and enforces the principle of least privilege.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0811',
    questionCategory: 'Redundancy of Service',
    questionCategoryDescription: 'Redundancy could be provided for both critical ICS devices and services, such as back-up devices or hot-standbys.',
    question: 'Is there redundancy for critical cyber assets or services?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - some redundancy may exist for some cyber assets and services.',
    questionMetrics2: 'Partially Implemented - redundancy is designed into some critical cyber assets.',
    questionMetrics3: 'Largely Implemented - redundancy is designed into most critical cyber assets.', 
    questionMetrics4: 'Fully Implemented - redundancy is designed into all critical cyber assets and services, and this function is tested at least annually.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0922',
    questionCategory: 'Restrict File and Directory Permissions',
    questionCategoryDescription: 'Restrict access by setting directory and file permissions that are not specific to users or privileged accounts.',
    question: 'Is access to directories or files restricted?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - directories and files may be restricted for less than 10% of all data.',
    questionMetrics2: 'Partially Implemented - directory and file permissions are restricted for critical data.',
    questionMetrics3: 'Largely Implemented - directory and file permissions are restricted for most critical data.', 
    questionMetrics4: 'Fully Implemented - directory and file permissions are restricted for all data, including locally stored files.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0944',
    questionCategory: 'Restrict Library Loading',
    questionCategoryDescription: 'Prevent abuse of library loading mechanisms in the operating system and software to load untrusted code by configuring appropriate library loading mechanisms and investigating potential vulnerable software.',
    question: 'Do you verfiy libraries, such as DLL files, before execution on cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - this capability may exist based on system defaults.',
    questionMetrics2: 'Partially Implemented code signing and signature verification technologies like AppLocker or Windows Defender Application Control (WDAC) are used on some critical cyber assets that support this capaibility.',
    questionMetrics3: 'Largely Implemented code signing and signature verification technologies like AppLocker or Windows Defender Application Control (WDAC) are used on all critical cyber assets that support this capaibility.', 
    questionMetrics4: 'Fully Implemented - code signing and signature verification technologies like AppLocker or Windows Defender Application Control (WDAC) are used on all cyber assets that support this capaibility. Cyber assets that do not support this technology are closely monitored.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0924',
    questionCategory: 'Restrict Registry Permissions',
    questionCategoryDescription: 'Restrict the ability to modify certain hives or keys in the Windows Registry.',
    question: "Do you restrict Windows Registry modification using the 'security descriptor' defined in Microsoft's Access Control Model?",
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0921',
    questionCategory: 'Restrict Web-Based Content',
    questionCategoryDescription: 'Restrict use of certain websites, block downloads/attachments, block Javascript, restrict browser extensions, etc.',
    question: 'Do you have a policy governing the use of mobile code, such as scripts embedded in documents or emails, websites, Java applets, JavaScript, HTML5, WebGL, and VBScript? Specific restrictions on mobile code should be tailored for your organization.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no policy exists or is not enforced.',
    questionMetrics2: 'Partially Implemented - a policy exists, but is only enforced for less than 50% of cyber assets.',
    questionMetrics3: 'Largely Implemented - policy exists, and is enforced for most cyber assets.', 
    questionMetrics4: 'Fully Implemented - policy exists and is enforced for all cyber assets. It requires minimum password length and complexity. Password reuse is prohibited, and passwords must be changed annually. Shared accounts are limited to cyber assets that cannot support individual user accounts.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0812',
    questionCategory: 'Safety Instrumented Systems',
    questionCategoryDescription: 'Utilize Safety Instrumented Systems (SIS) to provide an additional layer of protection to hazard scenarios that may cause property damage. A SIS will typically include sensors, logic solvers, and a final control element that can be used to automatically respond to an hazardous condition . Ensure that all SISs are segmented from operational networks to prevent them from being targeted by additional adversarial behavior.',
    question: 'Do you use Safety Instrumented Systems (SIS) to provide an additional layer of protection to hazard scenarios that may cause property damage?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such capability has been considered.',
    questionMetrics2: 'Partially Implemented - SIS exists for some cyber assets, but the need for additional SIS has not been assessed.',
    questionMetrics3: 'Largely Implemented SIS exists for most systems and the need for additional SIS has been assessed.', 
    questionMetrics4: 'Fully Implemented SIS exist for all systems and is segmented from other zones to prevent compromise.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0954',
    questionCategory: 'Software Configuration',
    questionCategoryDescription: 'Implement configuration changes to software (other than the operating system) to mitigate security risks associated with how the software operates.',
    question: 'Do you securely configure software based on vendor guidance?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0813',
    questionCategory: 'Software Process and Device Authentication',
    questionCategoryDescription: 'Require the authentication of devices and software processes where appropriate. Devices that connect remotely to other systems should require strong authentication to prevent spoofing of communications. Furthermore, software processes should also require authentication when accessing APIs.',
    question: 'Are devices and services required to authenticate to the domain or authenticate all messages between cyber assets?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0920',questionCategory: 'SSL/TLS Inspection',
    questionCategoryDescription: 'Break and inspect SSL/TLS sessions to look at encrypted web traffic for adversary activity.',
    question: 'Do you inspect SSL/TLS sessions for malicious traffic? ',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0814',
    questionCategory: 'Static Network Configuration',
    questionCategoryDescription: 'Configure hosts and devices to use static network configurations when possible, protocols that require dynamic discovery/addressing (e.g., ARP, DHCP, DNS) can be used to manipulate network message forwarding and enable various AiTM attacks. This mitigation may not always be usable due to limited device features or challenges introduced with different network configurations.',
    question: 'Do you use static network addresses for this zone?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0817',
    questionCategory: 'Supply Chain Management',
    questionCategoryDescription: 'Implement a supply chain management program, including policies and procedures to ensure all devices and components originate from a trusted supplier and are tested to verify their integrity.',
    question: 'Do you have a supply chain management program?', 
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no supply chain management program exists or is not enforced.',
    questionMetrics2: 'Partially Implemented - a supply chain management program exists, but is easily bypassed by users.',
    questionMetrics3: 'Largely Implemented - a supply chain management program that cannot be circumvented is in place.', 
    questionMetrics4: 'Fully Implemented - a supply chain management program that cannot be circumvented is in place and the integrity of cyber assets is verified when received.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0919',
    questionCategory: 'Threat Intelligence Program',
    questionCategoryDescription: 'A threat intelligence program helps an organization generate their own threat intelligence information and track trends to inform defensive priorities to mitigate risk.',
    question: 'Do you have a threat intelligence program that informs security operations, risk assessments, and configuration decisions?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such program exists.',
    questionMetrics2: 'Partially Implemented - threat intelligence is collected and occasionally reviewed.',
    questionMetrics3: 'Largely Implemented - a threat intelligence program exists and is regularly assessed.', 
    questionMetrics4: 'Fully Implemented - threat intelligence is integrated into security operations and is reviewed soon after it is recieved.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0951',
    questionCategory: 'Update Software',
    questionCategoryDescription: 'Perform regular software updates to mitigate exploitation risk. Software updates may need to be scheduled around operational down times.',
    question: 'Do you regularly perform software updates (patch management program)?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0918',
    questionCategory: 'User Account Management',
    questionCategoryDescription: 'Manage the creation, modification, use, and permissions associated to user accounts.',
    question: 'Are user accounts managed?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no rigorous process exist. User accounts are created or credentials for shared accounts are distributed when needed.',
    questionMetrics2: 'Partially Implemented - user accounts are created, modified, and deactivated when needed.',
    questionMetrics3: 'Largely Implemented - user accounts are created, modified, and deactivated with management approval.',
    questionMetrics4: 'Fully Implemented - user accounts are managed from account approval, creation, modification, use (account audting), and deactivation, including approval of assigned permissions.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0917',
    questionCategory: 'User Training',
    questionCategoryDescription: 'Train users to be aware of access or manipulation attempts by an adversary to reduce the risk of successful spearphishing, social engineering, and other techniques that involve user interaction.',
    question: 'Are users trained identify social engineering techniques, such as phishing (email), SMS-phishing, tailgating/piggybacking?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such program exists.',
    questionMetrics2: 'Partially Implemented - only initial user training is required.',
    questionMetrics3: 'Largely Implemented - initial and annual user training is required.', 
    questionMetrics4: 'Fully Implemented - initial and annual user training is required and exercised (phishing campaigns, tailgating attempts, etc.)',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0818',
    questionCategory: 'Validate Program Inputs',
    questionCategoryDescription: 'Devices and programs designed to interact with control system parameters should validate the format and content of all user inputs and actions to ensure the values are within intended operational ranges. These values should be evaluated and further enforced through the program logic running on the field controller. If a problematic or invalid input is identified, the programs should either utilize a predetermined safe value or enter a known safe state, while also logging or alerting on the event.',
    question: 'Are devices that interact with control systems designed to validate inputs against defined, operational ranges?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented - some critical assets validate inputs and block inputs that are out of tolerable range.',
    questionMetrics3: 'Largely Implemented - at least 50% of critical assets validate inputs, block inputs that are out of tolerable range, and log the event or alert operators or security personnel.', 
    questionMetrics4: 'Fully Implemented - at least 90% of critical assets validate inputs, block inputs that are out of tolerable range, and log the event or alert operators or security personnel.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0916',
    questionCategory: 'Vulnerability Scanning',
    questionCategoryDescription: 'Vulnerability scanning is used to find potentially exploitable software vulnerabilities to remediate them.',
    question: 'Are vulnerability scans regularly conducted?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no vulnerability scans are conducted for this zone.',
    questionMetrics2: 'Partially Implemented - vulnerability scans are periodically conducted and results are evaluated and remediated.',
    questionMetrics3: 'Largely Implemented - vulnerability scans are automated and system owners are required to address findings.', 
    questionMetrics4: 'Fully Implemented - a Vulnerability Management program is implemented, including policies and procedures, regularly updating vulnerability signatures, and findings are tracked to closure.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'M0815',
    questionCategory: 'Watchdog Timers',
    questionCategoryDescription: 'Utilize watchdog timers to ensure devices can quickly detect whether a system is unresponsive.',
    question: 'Do you have "watchdog" timers to ensure devices can quickly detect whether a system is unresponsive?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no such capability exist and the need for such a system has not been assessed.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to less than 50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0015',
    questionCategory: 'Application Log',
    questionCategoryDescription: 'Events collected by third-party services such as mail servers, web applications, or other appliances (not by the native OS or platform).',
    questionCategoryDescriptionVerbose: 'Monitor for:',
    questionCategoryDescriptionVerbose1: '1. Mode change to "Firmware Update Mode"',
    questionCategoryDescriptionVerbose2: '2. Newly installed applications',
    questionCategoryDescriptionVerbose3: '3. External remote services, especially those that do not require authentication)',
    questionCategoryDescriptionVerbose3: '4. Unexpected device restarts, shutdowns, or crashes',
    questionCategoryDescriptionVerbose4: '5. Access or access attempts to information respositories, especialy from privileged accounts',
    questionCategoryDescriptionVerbose5: '6. Known-bad domains in web traffic or use reputation based analytics (age of the domain, who it is register to, etc.)',
    questionCategoryDescriptionVerbose6: '7. Write commands for I/O points, including commands to an excessive number of I/O or manipulating a value an excessive number of times',
    questionCategoryDescriptionVerbose7: '8. Changes to settings or other events associated with network protocols commonly abused for Adversary-in-the-Middle (AiTM) attacks, such as ARP Spoofing (monitor ARP tables look for multiple IP addresses associated with the same MAC address), DNS Spoofing (monitor DNS queries and compare the resolved IP address with the DNS response IP), and SSL Stripping (monitor for https downgrades to http)',
    questionCategoryDescriptionVerbose8: '9. Application logs, where capable look for: changes to logging criteria; task parameter changes; configuration changes to the program or updates; access attempts; requests to read point or tag data or changes in volume of requests; new master devices communicating with outstations; new or unexpected devices, sessions;, or wireless networks; changes in network connection status from networking devices)',
    question: 'Do you monitor the application logs of mail servers, web applications, network devices, or other appliances?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0039',
    questionCategory: 'Asset',
    questionCategoryDescription: 'Data sources with information about the set of devices found within the network, along with their current software and configurations.',
    questionCategoryDescriptionVerbose: 'These benchmarks include expected alarm settings, configurations, expected parameter settings, expected program versions, and authorized cyber assets.',
    question: 'Is your asset management system used as a benchmark to compare expected cyber assets with behavior observed on the network/cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0017',
    questionCategory: 'Command',
    questionCategoryDescription: 'A directive given to a computer program, acting as an interpreter of some kind, in order to perform a specific task.',
    questionCategoryDescriptionVerbose: 'These commands may include arguments or parameters and are typically executed through interpreters such as cmd.exe, bash, zsh, PowerShell, or programmatic execution?',
    question: 'Do you monitoring the execution of textual commands (including shell commands, cmdlets, and scripts) within an operating system or application?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0016',
    questionCategory: 'Drive',
    questionCategoryDescription: 'A non-volatile data storage device (hard drive, floppy disk, USB flash drive) with at least one formatted partition, typically mounted to the file system and/or assigned a drive letter.',
    question: 'Do you monitor for newly constructed drive letters or mount points to removable media?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0022',
    questionCategory: 'File',
    questionCategoryDescription: 'A computer resource object, managed by the I/O system, for storing data (such as images, text, videos, computer programs, or any wide variety of other media).',
    question: 'Do you use file integrity monitoring (FIM), including file access, creation, modification, deletion, and metadata?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of critical cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0001',
    questionCategory: 'Firmware',
    questionCategoryDescription: 'Computer software that provides low-level control for the hardware and device(s) of a host, such as BIOS or UEFI/EFI.',
    question: 'Do you monitor for changes to firmware?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0028',
    questionCategory: 'Logon Session	',
    questionCategoryDescription: 'Logon occurring on a system or resource (local, domain, or cloud) to which a user/device is gaining access after successful authentication and authorization.',
    question: 'Do you monitor for new logon sessions and compare those sessions to expected behavior?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  },
  { 
    id:'DS0011',
    questionCategory: 'Module',
    questionCategoryDescription: 'Executable files consisting of one or more shared classes and interfaces, such as portable executable (PE) format binaries/dynamic link libraries (DLL), executable and linkable format (ELF) binaries/shared libraries, and Mach-O format binaries/shared libraries.',
    questionCategoryDescriptionVerbose: 'When a process or program dynamically attaches a shared library, module, or plugin into its memory space. This action is typically performed to extend the functionality of an application, access shared system resources, or interact with kernel-mode components.',
    questionCategoryDescriptionVerbose1: '1. Event Logging (Windows): Sysmon Event ID7, Windows Security Event ID 4688, and Windows Defender ATP.',
    questionCategoryDescriptionVerbose2: '2. Event Logging (Linux/macOS): AuditD, Ltrace/Strace, MacOS Endpoint Security Framework',
    questionCategoryDescriptionVerbose3: '3. Endpoint Detection & Response (EDR)',
    questionCategoryDescriptionVerbose3: '4. Memory Forensice: Volatility Framework',
    questionCategoryDescriptionVerbose4: '5. Security Information & Event Monitor (SIEM) and Log Analysis',
    questionCategoryDescriptionVerbose5: '6. Known-bad domains in web traffic or use reputation based analytics (age of the domain, who it is register to, etc.)',
    question: "Do you monitor the loading of shared libraries, modules, or plugins into a cyber asset's volatile memory ?",
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0033',
    questionCategory: 'Network Share',
    questionCategoryDescription: 'A storage resource (typically a folder or drive) made available from one host to others using network protocols, such as Server Message Block (SMB) or Network File System (NFS).',
    question: 'Do you monitor for unexpected network share access?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - no monitoring for this type of activity.',
    questionMetrics2: 'Partially Implemented - some monitoring for this type of activity occurs.',
    questionMetrics3: 'Largely Implemented - most network shares are monitored for unexpected access or large data transfers.', 
    questionMetrics4: 'Fully Implemented - all network shares are monitored for unexpected access or large data transfers.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0029',
    questionCategory: 'Network Traffic',
    questionCategoryDescription: 'Data transmitted across a network (ex: Web, DNS, Mail, File, etc.), that is either summarized (ex: Netflow) and/or captured as raw data in an analyzable format (ex: PCAP).',
    question: 'Do you monitor network traffic, such as Web, DNS, Mail, File, etc.?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented - less than 10% of network traffic is monitored.',
    questionMetrics2: 'Partially Implemented - network traffic flow is monitored at the edge of most zones.',
    questionMetrics3: 'Largely - network traffic flow data and at least some content (PCAP data) is monitored at the zone edge.', 
    questionMetrics4: 'Fully Implemented - network traffic flow and content (PCAP data) is monitored at the zone edge and new connection creation events are monitoried at all critical cyber assets.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0040',
    questionCategory: 'Operational Databases',
    questionCategoryDescription: 'Operational databases contain information about the status of the operational process and associated devices, including any measurements, events, history, or alarms that have occurred.',
    question: 'Do you monitor alarms, process history, or process events logged for cyber assets in operational databases?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this dectection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0009',
    questionCategory: 'Process',
    questionCategoryDescription: 'Instances of computer programs that are being executed by at least one thread. Processes have memory space for process executables, loaded modules (DLLs or shared libraries), and allocated memory regions containing everything from user input to application-specific data structures.',
    question: 'Do you monitor API execution, process creation, process metadata, and process termination events on your cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0003',
    questionCategory: 'Scheduled Job	',
    questionCategoryDescription: 'Automated tasks that can be executed at a specific time or on a recurring schedule running in the background (ex: Cron daemon, task scheduler, BITS).',
    question: 'Do you monitor scheduled job creation or modification events on your cyber assets?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  },
  { 
    id:'DS0012',
    questionCategory: 'Script',
    questionCategoryDescription: 'A file or stream containing a list of commands, allowing them to be launched in sequence.',
    question: 'Do you monitor for file permissions being updated or attempts to be updated to enable execution on a system?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0019',
    questionCategory: 'Service',
    questionCategoryDescription: 'A computer process that is configured to execute continuously in the background and perform system tasks, in some cases before any user has logged in. This includes the registration of a new service or daemon on an operating system. ',
    question: 'Do you monitor service creation or modification events on your cyber assets??',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0002',
    questionCategory: 'User Account',
    questionCategoryDescription: 'A profile representing a user, device, service, or application used to authenticate and access resources.',
    question: 'Do you monitor successful or failed login attemps or the creation, deletion, and modification of user accounts?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  }, 
  { 
    id:'DS0024',
    questionCategory: 'Windows Registry',
    questionCategoryDescription: 'A Windows OS hierarchical database that stores much of the information and settings for software programs, hardware devices, user preferences, and operating-system configurations.',
    question: 'Do you monitor key deletion or modification to Windows Registries?',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this detection applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this detection applies to around 11-50% of critical cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this detection applies to around 51-89% of critical cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this detection applies to around 90-100% of critical cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: ''
  },
  // { 
  //   id:'M0816',
  //   questionCategory: 'Mitigation Limited or Not Effective',
  //   questionCategoryDescription: 'This type of attack technique cannot be easily mitigated with preventative controls since it is based on the abuse of system features.',
  //   questionMetricTitle: 'Answer Definitions',
  //   questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
  //   questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
  //   questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
  //   questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
  //   questionMetrics5: '',
  //   questionTextAug1: '1. Not Implemented.',
  //   questionTextAug2: '2. Partially Implemented.',
  //   questionTextAug3: '3. Largely Implemented.',
  //   questionTextAug4: '4. Fully Implemented.',
  //   questionNumber: '1. ',
  //   questionTitle: ''
  // },
  // {
  //   id:'',
  //   questionCategory: '',
  //   questionCategoryDescription: '.',
  //   question: '?',
  //   questionMetricTitle: 'Answer Definitions',
  //   questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
  //   questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of critical cyber assets in the specific zone.',
  //   questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of critical cyber assets in the specific zone.', 
  //   questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of critical cyber assets in the specific zone.',
  //   questionMetrics5: '',
  //   questionTextAug1: '1. Not Implemented.',
  //   questionTextAug2: '2. Partially Implemented.',
  //   questionTextAug3: '3. Largely Implemented.',
  //   questionTextAug4: '4. Fully Implemented.',
  //   questionNumber: '1. ',
  //   questionTitle: ''
  // }, 
  // { 
  //   id:'',
  //   questionCategory: '',
  //   questionCategoryDescription: '.',
  //   question: '?',
  //   questionMetricTitle: 'Answer Definitions',
  //   questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
  //   questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of critical cyber assets in the specific zone.',
  //   questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of critical cyber assets in the specific zone.', 
  //   questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of critical cyber assets in the specific zone.',
  //   questionMetrics5: '',
  //   questionTextAug1: '1. Not Implemented.',
  //   questionTextAug2: '2. Partially Implemented.',
  //   questionTextAug3: '3. Largely Implemented.',
  //   questionTextAug4: '4. Fully Implemented.',
  //   questionNumber: '1. ',
  //   questionTitle: ''
  // }, 
];

const assetDeterminationQuestionsOriginal = [
  {
    id: 'M0801',
    questionCategory: 'Access Management',
    questionCategoryDescription: 'Access Management technologies can be used to enforce authorization polices and decisions, especially when existing field devices do not provided sufficient capabilities to support user identification and authentication. These technologies typically utilize an in-line network device or gateway system to prevent access to unauthenticated users, while also integrating with an authentication service to first verify user credentials.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: 'M0801'
  },
  {
    id: 'M0936',
    questionCategory: 'Account Use Policies',
    questionCategoryDescription: 'Configure features related to account use like login attempt lockouts, specific login times, password strength, removing default accounts/passwords, and inactivity lockout.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '2. ',
    questionTitle: ''
  },
  {
    id: 'M0915',
    questionCategory: 'Active Directory Configuration',
    questionCategoryDescription: 'Configure Active Directory to prevent use of certain techniques; use security identifier (SID) Filtering, allowed logon times, access control lists, auditing capability.',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.',
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '3. ',
    questionTitle: 'External Access: Visual access w/asset protections based on physical location, structure/equipment, resiliency and facility security:'
  },
  { id:'M0949',questionCategory:'Antivirus/Antimalware',questionCategoryDescription:'Use signatures or heuristics to detect malicious software. Within industrial control environments, antivirus/antimalware installations should be limited to assets that are not involved in critical or real-time operations. To minimize the impact to system availability, all products should first be validated within a representative test environment before deployment to production systems.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { 
    id:'M0913',
    questionCategory: 'Application Developer Guidance',
    questionCategoryDescription: 'This mitigation describes any guidance or training given to developers of applications to avoid introducing security weaknesses. Ensure that applications and devices do not store sensitive data or credentials insecurely (e.g., plaintext credentials in code, published credentials in repositories, or credentials in public cloud storage).',
    questionMetricTitle: 'Answer Definitions',
    questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',
    questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',
    questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', 
    questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',
    questionMetrics5: '',
    questionTextAug1: '1. Not Implemented.',
    questionTextAug2: '2. Partially Implemented.',
    questionTextAug3: '3. Largely Implemented.',
    questionTextAug4: '4. Fully Implemented.',
    questionNumber: '1. ',
    questionTitle: 'M0913'}, 
  { id:'M0948',questionCategory: 'Application Isolation and Sandboxing',questionCategoryDescription: 'Restrict the execution of code to a virtual environment on or in-transit to an endpoint system.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0947',questionCategory: 'Audit',questionCategoryDescription: 'Perform audits or scans of systems, permissions, insecure software, insecure configurations, etc. to identify potential weaknesses. Perform periodic integrity checks of the device to validate the correctness of the firmware, software, programs, and configurations. Integrity checks, which typically include cryptographic hashes or digital signatures, should be compared to those obtained at known valid states, especially after events like device reboots, program downloads, or program restarts.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0800',questionCategory: 'Authorization Enforcement',questionCategoryDescription: 'The device or system should restrict read, manipulate, or execute privileges to only authenticated users who require access based on approved security policies. Role-based Access Control (RBAC) schemes can help reduce the overhead of assigning permissions to the large number of devices within an ICS. For example, IEC 62351 provides examples of roles used to support common system operations within the electric power sector , while IEEE 1686 defines standard permissions for users of IEDs.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0946',questionCategory: 'Boot Integrity',questionCategoryDescription: 'Use secure methods to boot a system and verify the integrity of the operating system and loading mechanisms.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0945',questionCategory: 'Code Signing',questionCategoryDescription: 'Enforce binary and application integrity with digital signature verification to prevent untrusted code from executing.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0802',questionCategory: 'Communication Authenticity',questionCategoryDescription: 'When communicating over an untrusted network, utilize secure network protocols that both authenticate the message sender and can verify its integrity. This can be done either through message authentication codes (MACs) or digital signatures, to detect spoofed network messages and unauthorized connections.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0953',questionCategory: 'Data Backup',questionCategoryDescription: 'Take and store data backups from end user systems and critical servers. Ensure backup and storage systems are hardened and kept separate from the corporate network to prevent compromise. Maintain and exercise incident response plans , including the management of "gold-copy" back-up images and configurations for key systems to enable quick recovery and response from adversarial activities that impact control, view, or availability.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0803',questionCategory: 'Data Loss Prevention',questionCategoryDescription: 'Data Loss Prevention (DLP) technologies can be used to help identify adversarial attempts to exfiltrate operational information, such as engineering plans, trade secrets, recipes, intellectual property, or process telemetry. DLP functionality may be built into other security products such as firewalls or standalone suites running on the network and host-based agents. DLP may be configured to prevent the transfer of information through corporate resources such as email, web, and physical media such as USB for host-based solutions.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0942',questionCategory: 'Disable or Remove Feature or Program',questionCategoryDescription: 'Remove or deny access to unnecessary and potentially vulnerable software to prevent abuse by adversaries.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0808',questionCategory: 'Encrypt Network Traffic',questionCategoryDescription: 'Utilize strong cryptographic techniques and protocols to prevent eavesdropping on network communications.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0941',questionCategory: 'Encrypt Sensitive Information',questionCategoryDescription: 'Protect sensitive data-at-rest with strong encryption.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0938',questionCategory: 'Execution Prevention',questionCategoryDescription: 'Block execution of code on a system through application control, and/or script blocking.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0950',questionCategory: 'Exploit Protection',questionCategoryDescription: 'Use capabilities to detect and block conditions that may lead to or be indicative of a software exploit occurring.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0937',questionCategory: 'Filter Network Traffic',questionCategoryDescription: 'Use network appliances to filter ingress or egress traffic and perform protocol-based filtering. Configure software on endpoints to filter network traffic. Perform inline allow/denylisting of network messages based on the application layer (OSI Layer 7) protocol, especially for automation protocols. Application allowlists are beneficial when there are well-defined communication sequences, types, rates, or patterns needed during expected system operations. Application denylists may be needed if all acceptable communication sequences cannot be defined, but instead a set of known malicious uses can be denied (e.g., excessive communication attempts, shutdown messages, invalid commands). Devices performing these functions are often referred to as deep-packet inspection (DPI) firewalls, context-aware firewalls, or firewalls blocking specific automation/SCADA protocol aware firewalls.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0804',questionCategory: 'Human User Authentication',questionCategoryDescription: 'Require user authentication before allowing access to data or accepting commands to a device. While strong multi-factor authentication is preferable, it is not always feasible within ICS environments. Performing strong user authentication also requires additional security controls and processes which are often the target of related adversarial techniques (e.g., Valid Accounts, Default Credentials). Therefore, associated ATT&CK mitigations should be considered in addition to this, including Multi-factor Authentication, Account Use Policies, Password Policies, User Account Management, Privileged Account Management, and User Account Control.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0935',questionCategory: 'Limit Access to Resource Over Network',questionCategoryDescription: 'Prevent access to file shares, remote access to systems, unnecessary services. Mechanisms to limit access may include use of network concentrators, RDP gateways, etc.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0934',questionCategory: 'Limit Hardware Installation',questionCategoryDescription: 'Block users or groups from installing or using unapproved hardware on systems, including USB devices.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0805',questionCategory: 'Mechanical Protection Layers',questionCategoryDescription: 'Utilize a layered protection design based on physical or mechanical protection systems to prevent damage to property, equipment, human safety, or the environment. Examples include interlocks, rupture disk, release values, etc.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0806',questionCategory: 'Minimize Wireless Signal Propagation',questionCategoryDescription: 'Wireless signals frequently propagate outside of organizational boundaries, which provide opportunities for adversaries to monitor or gain unauthorized access to the wireless network. To minimize this threat, organizations should implement measures to detect, understand, and reduce unnecessary RF propagation.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0816',questionCategory: 'Mitigation Limited or Not Effective',questionCategoryDescription: 'This type of attack technique cannot be easily mitigated with preventative controls since it is based on the abuse of system features.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0932',questionCategory: 'Multi-factor Authentication',questionCategoryDescription: 'Use two or more pieces of evidence to authenticate to a system; such as username and password in addition to a token from a physical smart card or token generator. Within industrial control environments assets such as low-level controllers, workstations, and HMIs have real-time operational control and safety requirements which may restrict the use of multi-factor.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0807',questionCategory: 'Network Allowlists',questionCategoryDescription: 'Network allowlists can be implemented through either host-based files or system hosts files to specify what connections (e.g., IP address, MAC address, port, protocol) can be made from a device. Allowlist techniques that operate at the application layer (e.g., DNP3, Modbus, HTTP) are addressed in Filter Network Traffic mitigation.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0931',questionCategory: 'Network Intrusion Prevention',questionCategoryDescription: 'Use intrusion detection signatures to block traffic at network boundaries. In industrial control environments, network intrusion prevention should be configured so it will not disrupt protocols and communications responsible for real-time functions related to control or safety.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0930',questionCategory: 'Network Segmentation',questionCategoryDescription: 'Architect sections of the network to isolate critical systems, functions, or resources. Use physical and logical segmentation to prevent access to potentially sensitive systems and information. Use a DMZ to contain any internet-facing services that should not be exposed from the internal network. Restrict network access to only required systems and services. In addition, prevent systems from other networks or business functions (e.g., enterprise) from accessing critical process control systems. For example, in IEC 62443, systems within the same secure level should be grouped into a zone, and access to that zone is restricted by a conduit, or mechanism to restrict data flows between zones by segmenting the network.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0928',questionCategory: 'Operating System Configuration',questionCategoryDescription: 'Make configuration changes related to the operating system or a common feature of the operating system that result in system hardening against techniques.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0809',questionCategory: 'Operational Information Confidentiality',questionCategoryDescription: 'Deploy mechanisms to protect the confidentiality of information related to operational processes, facility locations, device configurations, programs, or databases that may have information that can be used to infer organizational trade-secrets, recipes, and other intellectual property (IP).',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0810',questionCategory: 'Out-of-Band Communications Channel',questionCategoryDescription: 'Have alternative methods to support communication requirements during communication failures and data integrity attacks.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0927',questionCategory: 'Password Policies',questionCategoryDescription: 'Set and enforce secure password policies for accounts.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0926',questionCategory: 'Privileged Account Management',questionCategoryDescription: 'Manage the creation, modification, use, and permissions associated to privileged accounts, including SYSTEM and root.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0811',questionCategory: 'Redundancy of Service',questionCategoryDescription: 'Redundancy could be provided for both critical ICS devices and services, such as back-up devices or hot-standbys.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0922',questionCategory: 'Restrict File and Directory Permissions',questionCategoryDescription: 'Restrict access by setting directory and file permissions that are not specific to users or privileged accounts.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0944',questionCategory: 'Restrict Library Loading',questionCategoryDescription: 'Prevent abuse of library loading mechanisms in the operating system and software to load untrusted code by configuring appropriate library loading mechanisms and investigating potential vulnerable software.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0924',questionCategory: 'Restrict Registry Permissions',questionCategoryDescription: 'Restrict the ability to modify certain hives or keys in the Windows Registry.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0921',questionCategory: 'Restrict Web-Based Content',questionCategoryDescription: 'Restrict use of certain websites, block downloads/attachments, block Javascript, restrict browser extensions, etc.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0812',questionCategory: 'Safety Instrumented Systems',questionCategoryDescription: 'Utilize Safety Instrumented Systems (SIS) to provide an additional layer of protection to hazard scenarios that may cause property damage. A SIS will typically include sensors, logic solvers, and a final control element that can be used to automatically respond to an hazardous condition . Ensure that all SISs are segmented from operational networks to prevent them from being targeted by additional adversarial behavior.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0954',questionCategory: 'Software Configuration',questionCategoryDescription: 'Implement configuration changes to software (other than the operating system) to mitigate security risks associated with how the software operates.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0813',questionCategory: 'Software Process and Device Authentication',questionCategoryDescription: 'Require the authentication of devices and software processes where appropriate. Devices that connect remotely to other systems should require strong authentication to prevent spoofing of communications. Furthermore, software processes should also require authentication when accessing APIs.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0920',questionCategory: 'SSL/TLS Inspection',questionCategoryDescription: 'Break and inspect SSL/TLS sessions to look at encrypted web traffic for adversary activity.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0814',questionCategory: 'Static Network Configuration',questionCategoryDescription: 'Configure hosts and devices to use static network configurations when possible, protocols that require dynamic discovery/addressing (e.g., ARP, DHCP, DNS) can be used to manipulate network message forwarding and enable various AiTM attacks. This mitigation may not always be usable due to limited device features or challenges introduced with different network configurations.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0817',questionCategory: 'Supply Chain Management',questionCategoryDescription: 'Implement a supply chain management program, including policies and procedures to ensure all devices and components originate from a trusted supplier and are tested to verify their integrity.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0919',questionCategory: 'Threat Intelligence Program',questionCategoryDescription: 'A threat intelligence program helps an organization generate their own threat intelligence information and track trends to inform defensive priorities to mitigate risk.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0951',questionCategory: 'Update Software',questionCategoryDescription: 'Perform regular software updates to mitigate exploitation risk. Software updates may need to be scheduled around operational down times.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0918',questionCategory: 'User Account Management',questionCategoryDescription: 'Manage the creation, modification, use, and permissions associated to user accounts.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0917',questionCategory: 'User Training',questionCategoryDescription: 'Train users to be aware of access or manipulation attempts by an adversary to reduce the risk of successful spearphishing, social engineering, and other techniques that involve user interaction.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0818',questionCategory: 'Validate Program Inputs',questionCategoryDescription: 'Devices and programs designed to interact with control system parameters should validate the format and content of all user inputs and actions to ensure the values are within intended operational ranges. These values should be evaluated and further enforced through the program logic running on the field controller. If a problematic or invalid input is identified, the programs should either utilize a predetermined safe value or enter a known safe state, while also logging or alerting on the event.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0916',questionCategory: 'Vulnerability Scanning',questionCategoryDescription: 'Vulnerability scanning is used to find potentially exploitable software vulnerabilities to remediate them.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 
  { id:'M0815',questionCategory: 'Watchdog Timers',questionCategoryDescription: 'Utilize watchdog timers to ensure devices can quickly detect whether a system is unresponsive.',questionMetricTitle: 'Answer Definitions',questionMetrics1: 'Not Implemented means this mitigation applies to around 0-10% of the cyber assets in the specific zone.',questionMetrics2: 'Partially Implemented means this mitigation applies to around 11-50% of the cyber assets in the specific zone.',questionMetrics3: 'Largely Implemented means this mitigation applies to around 51-89% of the cyber assets in the specific zone.', questionMetrics4: 'Fully Implemented means this mitigation applies to around 90-100% of the cyber assets in the specific zone.',questionMetrics5: '',questionTextAug1: '1. Not Implemented.',questionTextAug2: '2. Partially Implemented.',questionTextAug3: '3. Largely Implemented.',questionTextAug4: '4. Fully Implemented.',questionNumber: '1. ',questionTitle: ''}, 


];

const getTechniqueScores = async () => {

for (let zone in allZoneData) {
    // console.log(allZoneData[zone]);
    let id = allZoneData[zone]._id;
    let T0800 = allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 ;

        let T0830 = 		
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0019 +
            allZoneData[zone]?.DS0024
        
        let T0878 = 
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 
    
        let T0802 = 
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0012 
    
        let T0895 =
            allZoneData[zone]?.M0928 +
            allZoneData[zone]?.DS0016 +
            allZoneData[zone]?.DS0009

        let T0803 = 
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 +
            allZoneData[zone]?.DS0009 
        let T0804 =
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 +
            allZoneData[zone]?.DS0009 

        let T0805 = 
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 +
            allZoneData[zone]?.DS0009

        let T0806 = 
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 
        
        let T0892 = 
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.M0811 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040

        let T0858 = 
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.M0811 +
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0040
    
        let T0807 = 
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0009
        
        let T0885 = 
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.DS0029
    
        let T0884 = 
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0920 +
            allZoneData[zone]?.DS0029

        let T0879 = 
            allZoneData[zone]?.M0805 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0812 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009
        
        let T0809 = 
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0012
    
        let T0811 = 
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.M0917 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0033
        
        let T0893 = 
            allZoneData[zone]?.M0803 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.M0917 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0012
        
        let T0812 = 
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0029
        
        let T0813 = 
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0811
        
        let T0814 = 
            allZoneData[zone]?.M0815 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
    
        let T0815 = 
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0811
        
        let T0868 = 
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0029
    
        let T0816 = 
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0817 = 
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0950 +
            allZoneData[zone]?.M0921 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0871 = 
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.DS0009
        
        let T0819 = 
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0950 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.M0916 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0820 = 
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0950 +
            allZoneData[zone]?.M0919 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.DS0015
        
        let T0890 = 
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0950 +
            allZoneData[zone]?.M0919 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.DS0015
        
        let T0866 = 
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0950 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.M0919 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.M0916 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0822 = 
            allZoneData[zone]?.M0936 +
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0935 +
            allZoneData[zone]?.M0932 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0029
        
        let T0823 = 
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0011 +
            allZoneData[zone]?.DS0009
    
        let T0891 = 
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0029
        
        let T0874 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0944 +
            allZoneData[zone]?.DS0009
        
        let T0877 =
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0039   
        
        let T0872 =
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0024
        
        let T0883 =
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0029
        
        let T0867 = 
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0033 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0826 =
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0811
        
        let T0827 =
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0811
        
        let T0828 =
            allZoneData[zone]?.M0953
        
        let T0880 =
            allZoneData[zone]?.M0805 +
            allZoneData[zone]?.M0812
          
        let T0829 =
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810 +
            allZoneData[zone]?.M0811
        
        let T0835 =
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0039
        
        let T0831 =
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810
        
        let T0832 =
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0953 +
            allZoneData[zone]?.M0810
        
        let T0849 =
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0003 +
            allZoneData[zone]?.DS0019
        
        let T0838 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0821 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0040
        
        let T0836 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0818 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0889 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0839 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0946 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0808 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0001 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0801 =
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0834 =
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.DS0009
        
        let T0840 =
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0017
        
        let T0841 =
            allZoneData[zone]?.DS0009
        
        let T0842 =
            allZoneData[zone]?.M0808 +
            allZoneData[zone]?.M0932 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0012 +
            allZoneData[zone]?.DS0017
        
        let T0861 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0843 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040

        let T0845 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0873 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.DS0022
        
        let T0886 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0800 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0011 +
            allZoneData[zone]?.DS0033 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0846 =
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029
        
        let T0888 =
            allZoneData[zone]?.M0814 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0847 =
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0934 +
            allZoneData[zone]?.M0928 +
            allZoneData[zone]?.DS0016 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009
        
        let T0848 =
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0039 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 
        
        let T0851 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.DS0001
        
        let T0852 =
            // allZoneData[zone]?.M0816 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0009
        
        let T0853 =
            allZoneData[zone]?.M0948 +
            allZoneData[zone]?.M0942 +
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0011 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0012
        
        let T0881 =
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0922 +
            allZoneData[zone]?.M0924 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0019 +
            allZoneData[zone]?.DS0024
        
        let T0865 =
            allZoneData[zone]?.M0949 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0921 +
            allZoneData[zone]?.M0917 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0856 =
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040 +
            allZoneData[zone]?.DS0024
        
        let T0869 =
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.DS0029
        
        let T0862 =
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0817 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.M0916 +
            allZoneData[zone]?.DS0022
        
        let T0894 =
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0009 +
            allZoneData[zone]?.DS0012
        
        let T0857 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0946 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0808 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0804 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0001 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0882 =
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0809 +
            allZoneData[zone]?.M0922
        
        let T0864 =
            allZoneData[zone]?.M0949 +
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0941 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0951 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029
        
        let T0855 =
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0807 +
            allZoneData[zone]?.M0930 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.M0818 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0040
        
        let T0863 =
            allZoneData[zone]?.M0949 +
            allZoneData[zone]?.M0945 +
            allZoneData[zone]?.M0938 +
            allZoneData[zone]?.M0931 +
            allZoneData[zone]?.M0921 +
            allZoneData[zone]?.M0917 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0017 +
            allZoneData[zone]?.DS0022 +
            allZoneData[zone]?.DS0029 +
            allZoneData[zone]?.DS0009
        
        let T0859 =
            allZoneData[zone]?.M0801 +
            allZoneData[zone]?.M0936 +
            allZoneData[zone]?.M0915 +
            allZoneData[zone]?.M0913 +
            allZoneData[zone]?.M0947 +
            allZoneData[zone]?.M0937 +
            allZoneData[zone]?.M0932 +
            allZoneData[zone]?.M0927 +
            allZoneData[zone]?.M0926 +
            allZoneData[zone]?.M0918 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0002
        
        let T0860 = 
            allZoneData[zone]?.M0802 +
            allZoneData[zone]?.M0808 +
            allZoneData[zone]?.M0806 +
            allZoneData[zone]?.M0813 +
            allZoneData[zone]?.DS0015 +
            allZoneData[zone]?.DS0028 +
            allZoneData[zone]?.DS0029
        
        let T0887 =
            allZoneData[zone]?.M0808 +
            allZoneData[zone]?.M0806 +
            allZoneData[zone]?.DS0029
        
        let T0837 = 4;

    
    try {
        const responsePatch = await axiosPrivate.patch(`/zones/${id}`,
            JSON.stringify({ 
            T0800, 	T0830, 	T0878, 	T0802, 	T0895, 	T0803, 	T0804, 	T0805, 	T0806, 	T0892, 	T0858, 	T0807, 	T0885, 	T0884, 	T0879, 	T0809, 	T0811, 	T0893, 	T0812, 	T0813, 	T0814, 	T0815, 	T0868, 	T0816, 	T0817, 	T0871, 	T0819, 	T0820, 	T0890, 	T0866, 	T0822, 	T0823, 	T0891, 	T0874, 	T0877, 	T0872, 	T0883, 	T0867, 	T0826, 	T0827, 	T0828, 	T0837, 	T0880, 	T0829, 	T0835, 	T0831, 	T0832, 	T0849, 	T0838, 	T0821, 	T0836, 	T0889, 	T0839, 	T0801, 	T0834, 	T0840, 	T0842, 	T0861, 	T0843, 	T0845, 	T0873, 	T0886, 	T0846, 	T0888, 	T0847, 	T0848, 	T0851, 	T0852, 	T0853, 	T0881, 	T0865, 	T0856, 	T0869, 	T0862, 	T0894, 	T0857, 	T0882, 	T0864, 	T0855, 	T0863, 	T0859, 	T0860, 	T0887
            }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
            );
            const data = await responsePatch.data;
            // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
            // The console log commands below allow you to see the responses from Axios for the response.  
            // navigate(from, { replace: true });
    } catch (err) {
            // alert("Login Expired.Conswquence Threshold");
            // console.error(err);
            // navigate('/login', { state: { from: location }, replace: true });
    }
  };
};


const handleNextQuestion = () => {
  if (questionIndex === 67) {
    setActiveStep(6);  
  } else {
    getTechniqueScores();
    setQuestionIndex(questionIndex+1);
  }
  
  // getCriticalAssets();
};

const handlePreviousQuestion = () => {
  setQuestionIndex(questionIndex-1);
}
  
  const handleOpenInstructions = () => {
    setOpenInstructions(!openInstructions);
  };


  // Get zones for this assessment. 
    const getZones = async () => {
      try {
        const response = await axiosPrivate.get(`/zones/${assessmentID}`, {
            withCredentials: true
        });
        const data = await response.data;
        setAllZoneData(data);
        setRows(data);

        let tempUniqueAssetList = [];
        for (let i=0; i < data.length; i++) {
          let tempZoneData = JSON.parse(data[i].zoneData);
          for (let key in tempZoneData.assetTypes) {
            // console.log(tempZoneData.assetTypes[key]);
            if (tempZoneData.assetTypes[key]===true) {
              if (!tempUniqueAssetList.includes(key)) {
                tempUniqueAssetList.push(key);
              }
            }
          }
        } 
        setUniqueAssetList(tempUniqueAssetList);
        // handleBuildZoneNodes(data);
        // console.log(data);
      } catch (err) {
        // alert("Login Expired.");
        console.error(err);
        // navigate('/login', { state: { from: location }, replace: true });
      }
    };

  
    useEffect(() => {
        // getCriticalAssets();
        getZones();
      }, []);  // eslint-disable-line react-hooks/exhaustive-deps
      if (!rows) {
        return null;
      }


  // Columns for MUI Data Grid
  const columns = [
    {
        field: "zoneName",
        headerName: "Zone Name",
        flex: 1,
    },
    {
        field: "zoneDescription",
        headerName: "Description",
        flex: 2,
  },
    {
      field: columnFieldsFoot[questionIndex],
      flex: 2,
      sortable: false,
      renderHeader: () => {
        return (
          <Box>
            <Typography sx={{ fontSize: '1.5em'}}>
            <b>{physicalSecurityScenario[scenarioIndex].name}</b> <Tooltip color='primary' describeChild={true} title={<Typography sx={{ fontSize: '1.5em', background: 'grey' }}>{physicalSecurityScenario[scenarioIndex].description}</Typography>} placement="top-start"><HelpIcon /></Tooltip>
            </Typography>
            <Typography>
              {assetDeterminationQuestions[questionIndex].questionCategory}
            </Typography>
  
          </Box>
        )
      },
      renderCell: (params) => {
        return (
          <Box 
            sx={{ 
              "& .MuiRadio-root": {
                display:'inline',
              },
            }}>
              <Select
                value={params.row[columnFieldsFoot[questionIndex]] || 0}
                onChange={(e) => handleAssetUpdate(e.target.value, params)}
                onClick={handleEditClick(params.row)}
                sx={{ width: '500px', maxWidth: '100%' }}
              >
                <MenuItem value={0}>None</MenuItem>
                <MenuItem value={1}>{assetDeterminationQuestions[questionIndex].questionTextAug1}</MenuItem>
                <MenuItem value={2}>{assetDeterminationQuestions[questionIndex].questionTextAug2}</MenuItem>
                <MenuItem value={3}>{assetDeterminationQuestions[questionIndex].questionTextAug3}</MenuItem>
                <MenuItem value={4}>{assetDeterminationQuestions[questionIndex].questionTextAug4}</MenuItem>
                </Select>
          </Box>
        )
      }
    },
  ];

  // START:  Added to update Rows not Database on table cell change
  const handleRowEditStop = (id, event) => {
    if (id.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  
  const handleEditClick = (row) => () => {
    setRowModesModel({ ...rowModesModel, [row._id]: { mode: GridRowModes.Edit } });
  };
  
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row._id === newRow._id ? updatedRow : row)));
    // handleAssetUpdate2(updatedRow);
    return updatedRow;
  };

  // Update Database Function 
const handleAssetUpdate = async (e, params) => {
  // console.log(e);
  // console.log(params);
  for (let index in allZoneData) {
    if (allZoneData[index]._id===params.row._id) {
      // console.log(allZoneData[index]);
      allZoneData[index][params.field] = e;
      
      // console.log(allCriticalAssetData[index].externalAccess);
      let id = allZoneData[index]._id
      let M0801=allZoneData[index].M0801;
      let M0936=allZoneData[index].M0936;
      let M0915=allZoneData[index].M0915;
      let M0949=allZoneData[index].M0949;
      let M0913=allZoneData[index].M0913;
      let M0948=allZoneData[index].M0948;
      let M0947=allZoneData[index].M0947;
      let M0800=allZoneData[index].M0800;
      let M0946=allZoneData[index].M0946;
      let M0945=allZoneData[index].M0945;
      let M0802=allZoneData[index].M0802;
      let M0953=allZoneData[index].M0953;
      let M0803=allZoneData[index].M0803;
      let M0942=allZoneData[index].M0942;
      let M0808=allZoneData[index].M0808;
      let M0941=allZoneData[index].M0941;
      let M0938=allZoneData[index].M0938;
      let M0950=allZoneData[index].M0950;
      let M0937=allZoneData[index].M0937;
      let M0804=allZoneData[index].M0804;
      let M0935=allZoneData[index].M0935;
      let M0934=allZoneData[index].M0934;
      let M0805=allZoneData[index].M0805;
      let M0806=allZoneData[index].M0806;
      // let M0816=allZoneData[index].M0816;
      let M0816 = 0;
      let M0932=allZoneData[index].M0932;
      let M0807=allZoneData[index].M0807;
      let M0931=allZoneData[index].M0931;
      let M0930=allZoneData[index].M0930;
      let M0928=allZoneData[index].M0928;
      let M0809=allZoneData[index].M0809;
      let M0810=allZoneData[index].M0810;
      let M0927=allZoneData[index].M0927;
      let M0926=allZoneData[index].M0926;
      let M0811=allZoneData[index].M0811;
      let M0922=allZoneData[index].M0922;
      let M0944=allZoneData[index].M0944;
      let M0924=allZoneData[index].M0924;
      let M0921=allZoneData[index].M0921;
      let M0812=allZoneData[index].M0812;
      let M0954=allZoneData[index].M0954;
      let M0813=allZoneData[index].M0813;
      let M0920=allZoneData[index].M0920;
      let M0814=allZoneData[index].M0814;
      let M0817=allZoneData[index].M0817;
      let M0919=allZoneData[index].M0919;
      let M0951=allZoneData[index].M0951;
      let M0918=allZoneData[index].M0918;
      let M0917=allZoneData[index].M0917;
      let M0818=allZoneData[index].M0818;
      let M0916=allZoneData[index].M0916;
      let M0815=allZoneData[index].M0815;
      let DS0015=allZoneData[index].DS0015;
      let DS0039=allZoneData[index].DS0039;
      let DS0017=allZoneData[index].DS0017;
      let DS0016=allZoneData[index].DS0016;
      let DS0022=allZoneData[index].DS0022;
      let DS0001=allZoneData[index].DS0001;
      let DS0028=allZoneData[index].DS0028;
      let DS0011=allZoneData[index].DS0011;
      let DS0033=allZoneData[index].DS0033;
      let DS0029=allZoneData[index].DS0029;
      let DS0040=allZoneData[index].DS0040;
      let DS0009=allZoneData[index].DS0009;
      let DS0003=allZoneData[index].DS0003;
      let DS0012=allZoneData[index].DS0012;
      let DS0019=allZoneData[index].DS0019;
      let DS0002=allZoneData[index].DS0002;
      let DS0024=allZoneData[index].DS0024;


    try {
      const responsePatch = await axiosPrivate.patch(`/zones/${id}`,
        JSON.stringify({ 
          M0801,	M0936,	M0915,	M0949,	M0913,	M0948,	M0947,	M0800,	M0946,	M0945,	M0802,	M0953,	M0803,	M0942,	M0808,	M0941,	M0938,	M0950,	M0937,	M0804,	M0935,	M0934,	M0805,	M0806,	M0816,	M0932,	M0807,	M0931,	M0930,	M0928,	M0809,	M0810,	M0927,	M0926,	M0811,	M0922,	M0944,	M0924,	M0921,	M0812,	M0954,	M0813,	M0920,	M0814,	M0817,	M0919,	M0951,	M0918,	M0917,	M0818,	M0916,	M0815, DS0015, 	DS0039,	DS0017,	DS0016,	DS0022,	DS0001,	DS0028,	DS0011,	DS0033,	DS0029,	DS0040,	DS0009,	DS0003,	DS0012,	DS0019,	DS0002,	DS0024 
        }),
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
        );
        const data = await responsePatch.data;
        // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
        // The console log commands below allow you to see the responses from Axios for the response.  
        // navigate(from, { replace: true });
      } catch (err) {
        alert("Login Expired.Conswquence Threshold");
        console.error(err);
        navigate('/login', { state: { from: location }, replace: true });
      }
    }
  }
  };

const handleRowModesModelChange = (newRowModesModel) => {
  setRowModesModel(newRowModesModel);
};

const handleOpenDetectionAssessment = () => {
  setOpenOriginalText(!openOriginalText);
};

const handleOpenQuestionMetrics = () => {
  setOpenQuestionMetrics(!openQuestionMetrics);
};


for (let item in uniqueAssetList) {
  // console.log(uniqueAssetList[item]);
  if (uniqueAssetList[item] === "applicationServer") {
    // console.log(uniqueAssetList[item]);
    // console.log("app server added");
    assessmentAssetTypeList.push(...appSrvr);
  }
   if (uniqueAssetList[item] === "controlServer") {
    assessmentAssetTypeList.push(...cntlSrvr);
  }
   if (uniqueAssetList[item] === "dataGateway") {
    assessmentAssetTypeList.push(...dataGtwy);
  }
  if (uniqueAssetList[item] === "dataHistorian") {
    assessmentAssetTypeList.push(...dataHstrn);
  }
   if (uniqueAssetList[item] === "fieldio") {
    assessmentAssetTypeList.push(...fldIO);
  }
   if (uniqueAssetList[item] === "hmi") {
    assessmentAssetTypeList.push(...hmiMitList);
  }
  if (uniqueAssetList[item] === "ied") {
    assessmentAssetTypeList.push(...iedMitList);
  }
   if (uniqueAssetList[item] === "jumpHost") {
    assessmentAssetTypeList.push(...jmpHst);
  }
   if (uniqueAssetList[item] === "plc") {
    assessmentAssetTypeList.push(...plcMitList);
  }
  if (uniqueAssetList[item] === "rtu") {
    assessmentAssetTypeList.push(...rtuMitList);
  }
   if (uniqueAssetList[item] === "routers") {
    assessmentAssetTypeList.push(...routersMitList);
  }
   if (uniqueAssetList[item] === "safetyController") {
    assessmentAssetTypeList.push(...sftyCntrol);
  }
     if (uniqueAssetList[item] === "vpnRouters") {
    assessmentAssetTypeList.push(...vpnSrvr);
  }
   if (uniqueAssetList[item] === "workstations") {
    assessmentAssetTypeList.push(...workstationsMitList);
  }
};

const uniqueList = [...new Set(assessmentAssetTypeList)];

for (let item in uniqueList) {
  for (let index in assetDeterminationQuestions) {
    if (uniqueList[item] === assetDeterminationQuestions[index].id) {
      dynamicQuestionList.push(assetDeterminationQuestions[index]);
    }
  }
};


  return (
    <div>
      <Box sx={{ marginTop:'1em', flexGrow: 1 }}>
       {questionIndex<=67 ? (
         <>
           <Header title='Asset Assessment' subtitle='Answer each question for your defined Zones.' />
             <Grid container spacing={1}>
               <Grid item xs={12}>
                 <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.25rem", mr:'0.55rem', p:'4px'}} >
                   <Grid item xs={12} sx={{ p:'0.5rem' }}>
                     {openInstructions ? (
                         <IconButton color="primary"  aria-label="open or close instructions" onClick={handleOpenInstructions} >
                             <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="large" />
                             <Typography variant='h3' sx={{ ml: '1.5rem' }}><u>Instructions</u>:</Typography>
                         </IconButton>
                           ) : (
                             <IconButton color="primary"  aria-label="open or close detection and response" onClick={handleOpenInstructions} >
                               <ExpandCircleDownIcon color='primary' fontSize="large" />
                               <Typography variant='h3' sx={{ ml: '1.5rem' }}>Instructions</Typography>
                             </IconButton>
                           )}
                         <Divider sx={{ border:0.5, mt:'6px' }}/>
                     </Grid>
                     <Collapse in={openInstructions} timeout="auto" unmountOnExit>
                         <Grid container spacing={1}>
                             <Grid item xs={12} sx={{ ml:'2rem' }}>
                                 <Typography>Select the answer that most accurately represents each zone. Additional information about each question can be found under "Original Mitigation Text".</Typography>
                                 <Typography>This assessment is based on the Mitre's Adversarial Tactics, Techniques, and Common Knowledge (ATT&CK) framework for <Link rel='noreferrer' target='_blank' href="https://attack.mitre.org/docs/ATTACK_for_ICS_Philosophy_March_2020.pdf">Industrial Control Systems.</Link></Typography>
                                 <Typography></Typography>
                                 <Typography></Typography>
                             </Grid>
                             <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography>1. Read the security question.</Typography>
                              </Grid>
                              <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography>2. Click on table where the zone aligns with the "Answer" column.</Typography>
                              </Grid>
                              <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography>3. Select the best answer.</Typography>
                              </Grid>
                              <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                  <Box
                                    sx={{ pl:'2rem', pr:'2rem', minWidth:'50px', mb:'1rem' }}
                                    component="img"
                                    width="80%"
                                    alt="Image of your cursor hovering over the table."
                                    src={step1AnswerTable}
                                    />
                              </Grid>
                              <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Box
                                    sx={{ pl:'2rem', pr:'2rem', minWidth:'50px', mb:'1rem' }}
                                    component="img"
                                    width="100%"
                                    alt="Image of your cursor hovering over the table."
                                    src={step2AnswerTable}
                                    />
                              </Grid>
                              <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                  <Box
                                    sx={{ pl:'2rem', pr:'2rem', minWidth:'50px', mb:'1rem' }}
                                    component="img"
                                    width="100%"
                                    alt="Image of your cursor hovering over the table."
                                    src={step3AnswerTable}
                                    />
                              </Grid>
                         </Grid>
                     </Collapse>
                 </Paper>
               </Grid>
             </Grid>
          
              <Grid container spacing={1} >
                <Grid item xs={6}>
                <Paper sx={{ display: 'block', marginTop:'1rem', backgroundImage: "none", borderRadius: "0.55rem", mt:'0.55rem', p:'1rem', minHeight:'150px', justifyContent: 'space-between' }} >
                  <Box sx={{ fontSize: 26 }}>
                  <Box display='flex' justifyContent='space-between'>
                    <Typography display='inline' variant='h2'>Cybersecurity Questions</Typography>
                    <Typography display='inline' variant='h2' sx={{ mr: '1rem' }}>{questionIndex+1} / {assetDeterminationQuestions.length}</Typography>
                    </Box>
                    <Typography sx={{ display:'flex', justifyContent:'space-between'}}>
                      <Button disabled={questionIndex===0} sx={{ ml:'5%', m: '1rem'}} variant="contained" onClick={handlePreviousQuestion}>Previous Question</Button>
                      <Button sx={{ mr:'5%', m: '1rem'}} variant="contained" onClick={handleNextQuestion}>Next Question</Button>
                      {/* <Button sx={{ display:'block', ml:'auto', mr:'5%', mt: '1rem'}} variant="contained" onClick={handleResults}>Results</Button>  */}
                    </Typography> 
                    <Box sx={{ p: '1rem', border: 'solid 1px'}}>
                      <Typography sx={{ fontSize: '1em', ml: '3rem', mb:'1rem' }}>
                        <b>Category: {assetDeterminationQuestions[questionIndex].questionCategory}</b>
                      </Typography>
                      <Typography sx={{ fontSize: 22, ml: '4rem' }}>
                        {assetDeterminationQuestions[questionIndex].question}
                      </Typography>
                      <Box>
                      {openOriginalText ? (
                      <IconButton color="primary" sx={{ mt: '1em '}} aria-label="open or close detection and response" onClick={handleOpenDetectionAssessment} >
                          <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="medium" />
                          <Typography variant='h3' sx={{ ml: '1rem' }}>Original Mitigation Text</Typography>
                      </IconButton>
                      ):(
                        <IconButton color="primary" sx={{ mt: '1em '}} aria-label="open or close detection and response" onClick={handleOpenDetectionAssessment} >
                          <ExpandCircleDownIcon color='primary' fontSize="medium" />
                          <Typography variant='h3' sx={{ ml: '1rem' }}>Original Mitigation Text</Typography>
                        </IconButton>
                      )}
                      <Collapse in={openOriginalText} timeout="auto" unmountOnExit>
                        <Grid container spacing={1} >
                          <Grid xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Divider sx={{ width: '95%', m:'1rem'}} />
                          </Grid>               
                        </Grid>
                      </Collapse>
                      <Collapse in={openOriginalText} timeout="auto" unmountOnExit>
                        <Typography sx={{ fontSize: 22, ml: '4rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescription}
                        </Typography>
                          <Typography sx={{ fontSize: 22, ml: '4rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose1}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose2}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose3}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose4}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose5}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose6}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose7}
                        </Typography>
                        <Typography sx={{ fontSize: 22, ml: '5rem' }}>
                          {assetDeterminationQuestions[questionIndex].questionCategoryDescriptionVerbose8}
                        </Typography>
                      </Collapse>
                      </Box>
                      <Box>
                      {openQuestionMetrics ? (
                      <IconButton color="primary" sx={{ mt: '1em '}} aria-label="open or close detection and response" onClick={handleOpenQuestionMetrics} >
                          <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="medium" />
                          <Typography variant='h3' sx={{ ml: '1rem' }}>Answer Descriptions</Typography>
                      </IconButton>
                      ):(
                        <IconButton color="primary" sx={{ mt: '1em '}} aria-label="open or close detection and response" onClick={handleOpenQuestionMetrics} >
                          <ExpandCircleDownIcon color='primary' fontSize="medium" />
                          <Typography variant='h3' sx={{ ml: '1rem' }}>Answer Descriptions</Typography>
                        </IconButton>
                      )}
                      <Collapse in={openQuestionMetrics} timeout="auto" unmountOnExit>
                        <Grid container spacing={1} >
                          <Grid xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Divider sx={{ width: '95%', m:'1rem'}} />
                          </Grid>               
                        </Grid>
                      </Collapse>
                      <Collapse in={openQuestionMetrics} timeout="auto" unmountOnExit>
                        <Typography sx={{ fontSize: 24, ml: '7rem', mt: '1rem' }}>
                        {assetDeterminationQuestions[questionIndex].questionMetricTitle}
                      </Typography>
                      <List>
                      {assetDeterminationQuestions[questionIndex].questionMetrics1?.length>=2 && (
                        <ListItem>
                        <ListItemIcon sx={{ ml: '8rem' }}>
                            <CircleIcon sx={{ fontSize: '8pt' }}  />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: 24 }}>
                          {assetDeterminationQuestions[questionIndex].questionMetrics1}
                          </Typography>
                        </ListItem>
                      )}
                      {assetDeterminationQuestions[questionIndex].questionMetrics2?.length>=2 && (
                        <ListItem>
                          <ListItemIcon sx={{ ml: '8rem' }}>
                            <CircleIcon sx={{ fontSize: '8pt' }}  />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: 24 }}>
                            {assetDeterminationQuestions[questionIndex].questionMetrics2}
                          </Typography>
                        </ListItem>
                      )}
                        {assetDeterminationQuestions[questionIndex].questionMetrics3?.length>=2 && (
                      <ListItem>
                          <ListItemIcon sx={{ ml: '8rem' }}>
                            <CircleIcon sx={{ fontSize: '8pt' }}  />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: 24 }}>
                        {assetDeterminationQuestions[questionIndex].questionMetrics3 || ""}
                      </Typography>
                      </ListItem>
                      )}
                      {assetDeterminationQuestions[questionIndex].questionMetrics4?.length>=2 && (
                      <ListItem>
                          <ListItemIcon sx={{ ml: '8rem' }}>
                            <CircleIcon sx={{ fontSize: '8pt' }}  />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: 24 }}>
                      
                        {assetDeterminationQuestions[questionIndex].questionMetrics4 || ""}
                      </Typography>
                      </ListItem>
                      )}
                      {assetDeterminationQuestions[questionIndex].questionMetrics5?.length>=2 && (
                        <ListItem>
                        <ListItemIcon sx={{ ml: '8rem' }}>
                          <CircleIcon sx={{ fontSize: '8pt' }}  />
                        </ListItemIcon>
                        <Typography sx={{ fontSize: 24 }}>
                        {assetDeterminationQuestions[questionIndex].questionMetrics5}
                    </Typography>
                    </ListItem>
                      )}
                      </List>
                      </Collapse>
                      </Box>
                    </Box>
                  </Box>
                  </Paper>
                </Grid>
                  
          {/** DATA GRID OF CYBER ASSETS */}
                <Grid item xs={6} >
                  <Box
                    className={classes.root}
                    sx={{
                    mt:'0.5rem', flexGrow: 1, backgroundColor: theme.palette.background.alt, borderRadius: "0.75rem",
                      height: 1000,
                      width: '100%',
                      typography: '44pt',
                      "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: theme.palette.secondary.alt,
                          color: theme.palette.secondary[100],
                          borderBottom: "solid 2px black",
                          borderTop: "solid 2px black"
                      },
                      "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: theme.palette.primary.light,
                      },
                      "& .MuiDataGrid-footerContainer": {
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.primary[100],
                          borderTop: "none"
                      },
                      "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                          color: `${theme.palette.secondary[200]} !important`,
                      },
                  }}
                  >
                    <DataGrid
                      rows={rows || []} 
                      getRowId={(row) => row._id}
                      columns={columns}
                      editMode="row"
                      loading={!rows}
                      columnHeaderHeight={112}
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      sx={{ fontSize: "1.25em" }}
                      getCellClassName={(params) => {
                        if (params.field === 'zoneName') {
                          return '';
                        }
                        if (params.field === 'zoneDescription') {
                          return '';
                        } 
                        // return 'hot'
                        console.log(params.value);
                        return Number(params.value) === 0 ? 'hot' : '';
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>

          </>
     ) : (
       <>
       {/* RESULTS CALLED AFTER THE SECURITY ASSESSMENT QUESTIONS HAVE BEEN ANSWERED. */}
       <Header title='Security Assessment' subtitle='Reference Chapter 6 of FERC Security Program for Hydropower Projects Revision 3.' />
         <Grid container spacing={0} direction='columns' sx={{ mb:'1rem' }}>
           <Grid item xs={12}>
             <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.55rem", m:'0.55rem', p:'4px', minHeight:'150px'}} >
               <Grid item xs={12} sx={{ p:'1rem' }}>
                 <Typography sx={{ fontSize:'1.5em' }}><u>Results</u>:</Typography>
                 <Typography sx={{ fontSize:'1.5em' }}>The table shows the score for each individual critical asset by attack type.  The Project Score is the average score of all critical assets by attack type.</Typography>
                 <Typography sx={{ fontSize:'1.5em' }}>This assessment tool is derived from FERC's <Link rel='noreferrer' target='_blank' href="https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.ferc.gov%2Fsites%2Fdefault%2Ffiles%2F2020-04%2Fsecurity-tool.xls&wdOrigin=BROWSELINK">Security Assessment Analysis Tool.</Link> The metrics, attack scenarios, and resulting quantitative score were created by FERC.</Typography>
                 <Typography sx={{ fontSize:'1.5em' }}></Typography>
               </Grid>
               <Grid item xs={12} sx={{ display: 'flex', p:'1rem', alignItems:'center' }}>
                 <Typography sx={{ fontSize:'1.5em' }}>Generally, a score of 44 is acceptable and requires no additional information. Anything below a 44 will require a plan and schedule to improve your secuirty program.</Typography>
               </Grid>
               {/* <Grid item xs={12} sx={{ display: 'flex', pl:'2rem', alignItems:'center' }}>
                 <Typography sx={{ fontSize:'1.5em' }}><FiberManualRecordIcon sx= {{ color: 'red' }} /> Requires attention. Develop a plan and schedule.
                   </Typography>
               </Grid>
               <Grid item xs={12} sx={{ display: 'flex', pl:'2rem', alignItems:'center' }}>
                 <Typography sx={{ fontSize:'1.5em' }}><FiberManualRecordIcon sx= {{ color: 'orange' }} /> Limited Acceptability. Requires additions and/or upgrades to the security program.  Develop a plan and schedule. 
                 </Typography>
               </Grid>
               <Grid item xs={12} sx={{ display: 'flex', pl:'2rem', alignItems:'center' }}>
                 <Typography sx={{ fontSize:'1.5em' }}><FiberManualRecordIcon sx= {{ color: 'yellow' }} /> Acceptable-under Modification. Develop a plan and schedule. 
                 </Typography>
               </Grid>
               <Grid item xs={12} sx={{ display: 'flex', pl:'2rem', alignItems:'center' }}>
                 <Typography sx={{ fontSize:'1.5em' }}><FiberManualRecordIcon sx= {{ color: 'green' }} /> Acceptable.
                 </Typography>
               </Grid> */}
               <Grid item xs={12}>
               <Divider sx={{ border:0.5, mt:'6px' }}/>
               </Grid>
             </Paper>
           </Grid>
         </Grid>
         {/* <Box>
        <Typography>1. Get all Techniques per Zone.</Typography>
        <Typography>2. Calculate each Technique in each Zone.</Typography>
        <Typography>3. Calculate the asset type score in each Zone.</Typography>
        <Typography>4. Add the asset type scores up for each Zone and display.</Typography>       
       </Box> */}
       <ZoneCreator />
       
       
       </>
     )} 
        
     </Box>

    </div>
  )
}

export default MATM;